module.exports = __webpack_public_path__ + "media/img/private-venue/hover-work-bbb5d89bcc7784b0c493f84dd71394cf.svg";